import React from 'react';
import { Link } from 'react-router-dom';
import { footerSections } from '../data/site-content';

const linkClass = 'text-muted transition-colors hover:text-gold';

const Footer = () => {
  return (
    <footer className='relative border-t border-line bg-ink text-bone'>
      <div className='container-site'>
        <div className='flex flex-col gap-8 border-b border-line py-16 md:flex-row md:items-end md:justify-between md:py-20'>
          <p className='h-display text-5xl md:text-7xl'>
            Ready for your
            <br />
            <span className='text-gold'>next piece?</span>
          </p>
          <Link to='/contact' className='btn-primary self-start md:self-auto'>
            Start Your Booking
          </Link>
        </div>

        <div className='grid grid-cols-2 gap-10 py-14 lg:grid-cols-3'>
          {footerSections.map((section, index) => (
            <div
              key={section.title}
              className={
                index === footerSections.length - 1
                  ? 'col-span-2 lg:col-span-1'
                  : undefined
              }
            >
              <h2 className='mb-5 text-xs font-semibold uppercase tracking-[0.25em] text-gold'>
                {section.title}
              </h2>
              <ul className='space-y-3 text-sm'>
                {section.links.map((link) => {
                  const Icon = link.icon;
                  const isInternalRoute =
                    link.href?.startsWith('/') && !link.href?.includes('#');

                  return (
                    <li key={link.label} className='flex items-center gap-3'>
                      {Icon ? (
                        <Icon size={16} className='text-muted' aria-hidden='true' />
                      ) : null}
                      {link.href ? (
                        isInternalRoute ? (
                          <Link to={link.href} className={linkClass}>
                            {link.label}
                          </Link>
                        ) : (
                          <a
                            href={link.href}
                            target={link.external ? '_blank' : undefined}
                            rel={link.external ? 'noreferrer' : undefined}
                            className={linkClass}
                          >
                            {link.label}
                          </a>
                        )
                      ) : (
                        <span className='text-muted'>{link.label}</span>
                      )}
                    </li>
                  );
                })}
              </ul>
            </div>
          ))}
        </div>

        <div className='flex flex-col gap-2 border-t border-line py-8 text-xs text-muted sm:flex-row sm:justify-between'>
          <span>
            © {new Date().getUTCFullYear()}{' '}
            <a
              href='https://darksidetattoos.co.uk/'
              className='hover:text-gold'
              target='_blank'
              rel='noreferrer'
            >
              Darkside Tattoos
            </a>
            . All rights reserved.
          </span>
          <span className='uppercase tracking-[0.2em]'>
            Est. 2011 · County Durham
          </span>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
